import $ from 'jquery'


class Presentation {

    // -- init presentation
    init() {
        try {
            this.rightPanelBtn = document.querySelector('.video_header_close_btn');
            this.mainContainer = document.querySelector("#main-container");

            this.infoQuestions = document.querySelector('.info-questions-container');
            this.reiterContainer = document.querySelector('.reiter-container');

            this.pdfContainer = document.querySelector('.pdf-container');
            if (this.pdfContainer) this.mainPdf = this.pdfContainer.querySelector('#main-pdf');

            /* Header Container - die Höhe wird benötigt für die Fullscreen Funktion togglePdf */
            this.headerContainer = document.querySelector('.header_cmeducation');

            this.slidesContainer = document.querySelector(".slides-container");

            this.allReiter = document.querySelectorAll('.reiter');

            this.allQuestionsContainer = document.querySelector(".all-questions-container");
            this.infoContainer = document.querySelector(".info-container");
            this.qrCodeContainer = document.querySelector(".qr-code-container");
            this.feedbackContainer = document.querySelector(".feedback-container");


            this.infoReiter = document.querySelector('.info-reiter');
            this.datenschutzErklaerung = document.querySelector('#datenschutz-erklaerung');

            // globaler Listener für Orientation Change
            window.screen.orientation.addEventListener('change', () => {
                //this.handleOrientationChange();
            });

            console.log('%cPräsentation erfolgreich geladen', 'color: #00ff00');
            return true;
        }
        catch (e) {
            console.log('%cFehler beim Initialisieren der Präsentation', 'color: #ff0000', e);

            return false;
        }
    }


    // -- Right Panel
    toggleRightPanel(e) {
        e.stopPropagation();

        this.rightPanelBtn.classList.toggle('close-grey');
        this.rightPanelBtn.classList.toggle('arrow-down-grey');

        if (this.mainContainer.getAttribute("fullwidth") === "true") {
            // open right panel
            this.mainContainer.setAttribute("fullwidth", "false")
        }
        else {
            // close right panel
            this.mainContainer.setAttribute("fullwidth", "true");
        }
    }

    // -- slides container
    toggleSlidesContainer(e) {
        e.stopPropagation();

        // set a attribute to main-container if slides are hidden
        if (this.mainContainer.getAttribute('slideshidden') === 'true') {
            this.mainContainer.setAttribute('slideshidden', 'false')
        }
        else {
            this.mainContainer.setAttribute('slideshidden', 'true');
        }

        // toggle button icon
        e.currentTarget.classList.toggle('resize-shrink-grey');
        e.currentTarget.classList.toggle('resize-grow-grey');

        // toggle vc-overlay
        $(this.slidesContainer).toggle();
    }

    // -- pdf container
    togglePdf(e) {

        // toggle icon
        var pdfFullscreenIcon = e.target;
        pdfFullscreenIcon.classList.toggle('resize-pdf-grow');
        pdfFullscreenIcon.classList.toggle('resize-pdf-shrink');

        // toggle attribute and displaying info/reiter container
        this.pdfContainer.toggleAttribute('active');

        $(this.reiterContainer).toggle();
        $(this.infoQuestions).toggle();

        if (this.pdfContainer.hasAttribute('active')) {
            // pdf fullscreen -> set height to current app-height -> better visualization in app
            const viewportHeight = window.innerHeight;
            const headerHeight = this.headerContainer.offsetHeight;
            const newHeight = viewportHeight - headerHeight;

            this.pdfContainer.style = `height: ${newHeight}px;`;
            this.mainPdf.style = "height: 100%;"
        }
        else {
            // pdf halfscreen
            this.pdfContainer.style = "height: 50vh;";
            this.mainPdf.style = "height: 50vh;"
        }
    }

    // -- Wissensfragen/Kursinfo/... reiter 
    toggleReiter(e) {
        // -- clicked Reiter
        const thisReiter = e.currentTarget;

        // -- already active
        if (thisReiter.classList.contains('reiter-active')) {
            // fire toggle click event for maximizing questions/info/etc
            var resizeIcon = document.querySelector('.resize-grow-grey');
            if (!resizeIcon) {
                resizeIcon = document.querySelector('.resize-shrink-grey');
            }
            resizeIcon.click();

            return;
        }

        // -- toggle container
        else {
            // select all reiter and remove active-attribute
            this.allReiter.forEach((singleReiter) => {
                singleReiter.classList.remove('reiter-active');
            })


            // -- activate or deactivate reiter
            const manageThisReiter = (reiter, container, reiterName) => {
                // check if container exists
                if (container) {

                    // check if reiter needs to be activated
                    const activate = reiter.classList.contains(reiterName);

                    if (activate) {
                        // add active class to reiter
                        reiter.classList.add("reiter-active");
                        // remove hidden-attribute from container
                        container.removeAttribute("hidden");
                    }
                    else {
                        // add hidden-attribute to container
                        container.setAttribute("hidden", "");
                    }
                }
            }


            // Wissensfragen            
            manageThisReiter(thisReiter, this.allQuestionsContainer, 'fragen-reiter');

            // Kursinfo            
            manageThisReiter(thisReiter, this.infoContainer, 'info-reiter');

            // QR-Code Container            
            manageThisReiter(thisReiter, this.qrCodeContainer, 'qr-code-reiter');

            // Feedback-Container            
            manageThisReiter(thisReiter, this.feedbackContainer, 'feedback-reiter')
        }
    }

    // -- go to datenschutzerklärung
    goToDatenschutz() {
        this.infoReiter.click();

        // wait a bit before scrolling in Kursinfo
        setTimeout(() => { this.datenschutzErklaerung.scrollIntoView() }, 200);
    }
}


const mainPresentation = new Presentation();



export { mainPresentation }